import axios from "axios";

const getClusterScanProductListing = (payload) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/analytic/api/v1/consumer/dashboard-scan-product", {
        start_date: payload.start_date,
        end_date: payload.end_date,
        longitude: payload.longitude,
        latitude: payload.latitude,
        length: payload.length,
        start: payload.start,
        search: payload.search,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
};

export default getClusterScanProductListing;
